import { httpGet } from "@cirrus/core/http"
import { LanguageCode } from "../../../CustomerInfo/types"

export type Translations = Record<string, any>

export class TranslationsService {
	constructor(args?: Partial<TranslationsService>) {
		for (const key in args) {
			this[key] = args[key]
		}
	}

	getTranslations = (language: LanguageCode) =>
		httpGet<Translations>("/api/v1/translations", { params: { lang: language } })

	persistLanguage = (language: LanguageCode) => sessionStorage.setItem("urlLang", language)

	getPersistedLanguage = () =>
		(sessionStorage.getItem("loginLang") ?? sessionStorage.getItem("urlLang")) as LanguageCode | null
}
